import _ from 'lodash'
import FileHandler from './file'
// import ObjectHandler from './object'
import ArrayHandler from './array'
import ApiFile from '@/apis/file'

class RequestHelper {
  static clearData (keyinfos, data, { instance = undefined, obj = undefined, doSetDefault = false } = {}) {
    if (!data) {
      console.error('invalid request data')
      return
    }

    for (let ki in keyinfos) {
      let keyinfo = keyinfos[ki]
      let key = keyinfo.key
      if (data.hasOwnProperty(key)) {
        // console.log('-- delete value for ' + key)
        delete data[key]
      }

      // set defaults
      if (doSetDefault &&
        keyinfo.hasOwnProperty('default')) {
        // console.log('-- set default value: ' + key, keyinfo.default)
        if (instance && obj) {
          instance.$set(obj, key, keyinfo.default)
        } else if (instance) {
          instance.$set(data, key, keyinfo.default)
        } else {
          data[key] = keyinfo.default
        }
      }
    }
  }

  static getDefaults (keyinfos) {
    let defaults = {}
    for (let ki in keyinfos) {
      let keyinfo = keyinfos[ki]
      let key = keyinfo.key
      let def = keyinfo.default
      if (def != null) {
        defaults[key] = def
      }
    }
    return defaults
  }

  static setDefaults (keyinfos, data, { instance = undefined } = {}) {
    // console.log('-- set defaults', {
    //   keyinfos,
    //   data
    // })
    if (!data) {
      console.error('invalid request data')
      return
    }

    for (let ki in keyinfos) {
      let keyinfo = keyinfos[ki]
      let key = keyinfo.key
      if (!keyinfo.hasOwnProperty('default')) continue
      // if (data.hasOwnProperty(key)) {
      //   // console.log('-- delete value for ' + key)
      //   continue
      // }
      if (data[key] != null) continue

      // set defaults
      // console.log('-- set default value: ' + key, keyinfo.default)
      if (instance && data) {
        instance.$set(data, key, keyinfo.default)
      }
    }
  }

  static parseForm (keyinfos, form, { doIsolate = true, doKeysOnly = true, numberToBoolean = true } = {}) {
    // format: { key, type, default }
    if (!form) {
      console.error('invalid request form')
      return
    }
    if (doIsolate) {
      form = _.assign({}, form)
    }

    let newForm = {}
    for (let ki in keyinfos) {
      let keyinfo = keyinfos[ki]

      // skip
      let skipForm = keyinfo.skipForm
      if (skipForm) continue

      // check key
      let key = keyinfo.key
      if (!form.hasOwnProperty(key)) {
        // ignore
        continue
      }

      // for null
      let type = keyinfo.type
      let value = form[key]
      if (value === null || value === undefined) {
        form[key] = undefined
        continue
      }

      // by vtype
      switch (type) {
        case 'string':
        case 'date':
          newForm[key] = form[key]
          break
        case 'float':
          if (isNaN(parseFloat(value))) {
            console.error(`invalid request key: ${key} for type: ${type}`)
            continue
          }
          newForm[key] = parseFloat(value)
          break
        case 'int':
          if (isNaN(parseInt(value, 10))) {
            console.error(`invalid request key: ${key} for type: ${type}`)
            continue
          }
          newForm[key] = parseInt(value, 10)
          break
        case 'bool':
        case 'boolean':
          if (numberToBoolean) {
            newForm[key] = (form[key] === 1 || form[key] === true) ? true : ((form[key] === 0 || form[key] === false) ? false : undefined)
          } else {
            newForm[key] = !!form[key]
          }
          break
        case 'file':
          newForm[key] = FileHandler.parse(form[key])
          break
        case 'object':
          newForm[key] = form[key]
          break
        case 'features':
          newForm[key] = _.map(form[key], (item) => {
            let featureName = item.featureName || 'feature'
            return {
              value: item[featureName]
            }
          })
          break
        case 'array':
          newForm[key] = form[key]
          break
        default:
          newForm[key] = form[key]
          console.error(`invalid request key: ${key} for type: ${type}`)
          break
      }
      let alias = keyinfo.alias
      if (alias && alias.length > 0) {
        newForm[alias] = newForm[key] // copy to alias
      }
    }
    if (!doKeysOnly) {
      newForm = _.assign({}, form, newForm)
    }
    return newForm
  }

  static stateGuard (instance, data, name) {
    if (!data.hasOwnProperty(`${name}State`)) {
      instance.$set(data, `${name}State`, {})
    }
    return data[`${name}State`]
  }

  static parseDataTable (keyinfos, data, options = {}) {
    if (!data || typeof data !== 'object' || !Array.isArray(data)) {
      console.error(`invalid request data or data type: ${typeof data}`)
      return
    }

    let table = []
    for (let d in data) {
      // console.log('-- index: ' + d, keyinfos)
      let item = data[d]
      item = _.assign({}, item)
      item = RequestHelper.parseData(keyinfos, item, options)

      // state
      for (let ki in keyinfos) {
        let keyinfo = keyinfos[ki]
        let type = keyinfo.type
        switch (type) {
          case 'input':
          case 'select':
            if (!item.hasOwnProperty(`${name}State`)) {
              item[`${name}State`] = {}
            }
            break
          default:
            break
        }
      }
      table.push(item)
    }
    return table
  }

  static parseData (keyinfos, data, { doCombine = false, doDeleteDataKey = false, booleanToNumber = false, setDefaults = true } = {}) {
    // format: { key, type, default }
    if (!data) {
      console.error('invalid request data')
      return
    }

    let form = {}
    for (let ki in keyinfos) {
      let keyinfo = keyinfos[ki]

      // check key
      let key = keyinfo.key
      let def = keyinfo.hasOwnProperty('default') ? keyinfo.default : null
      if (!data.hasOwnProperty(key)) {
        if (def !== null && setDefaults) {
          form[key] = def
        } else {
          form[key] = undefined
        }
        // ignore
        continue
      }

      // for null
      let type = keyinfo.type
      let value = data[key]
      if (value === null || value === undefined) {
        if (def !== null && setDefaults) {
          form[key] = def
        } else {
          form[key] = undefined
        }
        continue
      }

      // by vtype
      switch (type) {
        case 'string':
          form[key] = data[key]
          break
        case 'date':
          form[key] = data[key]
          if (keyinfo.hasOwnProperty('dateFormatter') && typeof keyinfo.dateFormatter === 'function') {
            let dateFormatter = keyinfo.dateFormatter
            form[key] = dateFormatter(form[key])
          }
          break
        case 'float':
          if (isNaN(parseFloat(value))) {
            console.error(`invalid request key: ${key} for type: ${type}`)
            continue
          }
          form[key] = parseFloat(value)
          break
        case 'int':
          if (isNaN(parseInt(value, 10))) {
            console.error(`invalid request key: ${key} for type: ${type}`)
            continue
          }
          form[key] = parseInt(value, 10)
          break
        case 'bool':
        case 'boolean':
          form[key] = data[key]
          if ((keyinfo.hasOwnProperty('booleanToNumber') && keyinfo.booleanToNumber) || booleanToNumber) {
            form[key] = data[key] ? 1 : 0
          }
          if (keyinfo.hasOwnProperty('forceBool') && keyinfo.forceBool) {
            form[key] = !!data[key]
          }
          break
        case 'file':
          form[key] = FileHandler.parse(data[key])
          break
        case 'object':
          form[key] = data[key]
          break
        case 'features':
          form[key] = _.map(data[key], (item) => {
            let featureName = item.featureName || 'feature'
            return {
              value: item[featureName]
            }
          })
          break
        case 'array':
          form[key] = data[key]
          break
        default:
          form[key] = data[key]
          console.error(`invalid request key: ${key} for type: ${type}`)
          break
      }
      let alias = keyinfo.alias
      if (alias && alias.length > 0) {
        data[alias] = form[key] // copy to alias
      }
      if (doDeleteDataKey) {
        delete data[key]
      }
    }
    if (doCombine) {
      form = _.assign({}, data, form)
    }
    return form
  }

  static parseFormula (data, formula, def = undefined) {
    if (!formula || formula.length <= 0) return def
    let fparams = formula.split(' ')
    fparams = _.filter(fparams, (item) => item.length > 1)
    fparams = _.sortBy(fparams, (item) => -item.length) // sort by longer param first, reduce subset
    // console.log('-- formula (before):', { formula, fparams, data })
    for (let fp in fparams) {
      let fparam = fparams[fp]
      if (!isNaN(parseFloat(fparam))) {
        // is number
        continue
      }
      if (!data.hasOwnProperty(fparam) ||
        isNaN(parseFloat(data[fparam]))) {
        return def
      }
      let regex = new RegExp(`${fparam}`, 'g')
      if (data.hasOwnProperty(fparam)) {
        formula = formula.replace(regex, data[fparam])
      }
    }
    // console.log('-- formula (after):', formula)
    let match = formula.match(/([A-Za-z])/g)
    if (match && match.length > 0) {
      return def
    }
    // console.log('-- success!!', match)
    // eslint-disable-next-line
    var EVAL_IS_BAD__AVOID_THIS = eval
    let result = EVAL_IS_BAD__AVOID_THIS(`(${formula})`)
    // console.log('-- formula (result):', result)
    if (!isNaN(result)) {
      return result
    }
    return def
  }

  static parseExpression (data, formula, def = undefined) {
    if (!formula || formula.length <= 0) return def
    // let fparams = formula.split(' ')
    // fparams = _.filter(fparams, (item) => item.length > 1)
    // fparams = _.sortBy(fparams, (item) => -item.length) // sort by longer param first, reduce subset
    let fparams = _.map(data, (item, key) => key)
    // fparams = _.filter(fparams, (item) => item.length > 1)
    fparams = _.sortBy(fparams, (item) => -item.length) // sort by longer param first, reduce subset
    // console.log('-- expression (before):', { formula, fparams, data })
    for (let fp in fparams) {
      let fparam = fparams[fp]
      if (!isNaN(parseFloat(fparam))) {
        // is number
        continue
      }
      let regex = new RegExp(`${fparam}`, 'g')
      if (data.hasOwnProperty(fparam)) {
        if (`${data[fparam]}`.length <= 0) data[fparam] = '\'\''
        formula = formula.replace(regex, data[fparam])
      }
    }
    // console.log('-- expression (after):', formula)
    // console.log('-- success!!', match)
    // eslint-disable-next-line
    var EVAL_IS_BAD__AVOID_THIS = eval
    let result = EVAL_IS_BAD__AVOID_THIS(`(${formula})`)
    // console.log('-- expression (result):', result)
    if (!isNaN(result)) {
      return result
    }
    return def
  }

  static parseLogs (logs, arrayInfos = []) {
    logs = _.map(logs, (log, index) => {
      let jsons = ['oldValue', 'newValue']
      for (let j in jsons) {
        let jsonType = jsons[j]
        let value = log[jsonType]
        if (value != null) {
          try {
            value = JSON.parse(value) || {}
          } catch (error) {
            console.error(`invalid log ${jsonType}: ${value} for #${index}`)
            value = {}
          }
        } else {
          value = {}
        }
        log[jsonType] = value
      }
      let newValue = _.assign({}, log.newValue)
      let oldValue = _.assign({}, log.oldValue)
      log.oldValue = _.pickBy(log.oldValue, (value, key) => {
        return (value !== (newValue && newValue[key]))
      })
      log.newValue = _.pickBy(log.newValue, (value, key) => {
        return (value !== (oldValue && oldValue[key]))
      })
      // let isDebug = log.logId === 34
      for (let a in arrayInfos) {
        let arrayInfo = arrayInfos[a]
        let arrayKey = arrayInfo.key
        let excludeKeys = arrayInfo.excludes || []
        // if (isDebug) {
        //   console.log('-- array key', {
        //     arrayKey,
        //     excludeKeys
        //   })
        // }
        if (log.oldValue.hasOwnProperty(arrayKey) && log.newValue.hasOwnProperty(arrayKey)) {
          let oldArray = ArrayHandler.copy(log.oldValue[arrayKey])
          oldArray = _.map(oldArray, (item) => {
            item = _.pickBy(item, (value, key) => !excludeKeys.includes(key))
            return item
          })
          let oldList = _.map(oldArray, (item) => JSON.stringify(item))
          let newArray = ArrayHandler.copy(log.newValue[arrayKey])
          newArray = _.map(newArray, (item) => {
            item = _.pickBy(item, (value, key) => !excludeKeys.includes(key))
            return item
          })
          let newList = _.map(newArray, (item) => JSON.stringify(item))
          // if (isDebug) {
          //   console.log('-- array key old new list', {
          //     oldArray,
          //     oldList,
          //     newArray,
          //     newList
          //   })
          // }

          // old array
          let oldArray2 = _.filter(oldArray, (item, index) => {
            item = _.pickBy(item, (value, key) => !excludeKeys.includes(key))
            let jstring = JSON.stringify(item)
            return !newList.includes(jstring)
          })
          // if (isDebug) {
          //   console.log('-- array key oldArray', oldArray)
          // }
          log.oldValue[arrayKey] = oldArray2

          // new array
          newArray = _.filter(newArray, (item) => {
            item = _.pickBy(item, (value, key) => !excludeKeys.includes(key))
            let jstring = JSON.stringify(item)
            return !oldList.includes(jstring)
          })
          log.newValue[arrayKey] = newArray
        }
      }
      return log
    })
    return logs
  }

  static translateLogs (logs, columns = [], formData = {}) {
    logs = ArrayHandler.copy(logs)
    // let columnsAll = Util.array.copy(columns)
    // columns = _.filter(columns, (col) => col.hasOwnProperty('data'))
    for (let c in columns) {
      let column = columns[c]
      let dataName = column.data
      if (!dataName || !formData[dataName]) continue
      column.datalist = formData[dataName]
    }
    // columns = _.filter(columns, (col) => col.hasOwnProperty('datalist'))

    logs = _.map(logs, (log) => {
      // each value objects (new/old)
      let valueKeys = ['newValue', 'oldValue']
      for (let v in valueKeys) {
        let valueKey = valueKeys[v]
        let obj = log[valueKey]

        // each columns
        for (let c in columns) {
          let column = columns[c]
          let name = column.name
          let datalist = column.datalist
          if (datalist && obj != null && obj.hasOwnProperty(name) && obj[name] != null) {
            let found = _.find(datalist, (dt) => dt.id === obj[name])
            if (found && found.label) {
              obj[name] = found.label
            } else {
              obj[name] = `${obj[name]} (Not Found)`
            }
          }

          let label = column.label
          if (label && obj != null && obj.hasOwnProperty(name)) {
            obj[label] = obj[name]
            delete obj[name]
          }
        }
      }
      return log
    })
    return logs
  }

  static async uploadAllFiles (instance, form = 'form', all = [], prefix = 'presales/supplier') {
    let files
    let paths

    if (!instance[form] || !all) {
      throw new Error('invalid form or uploaded files')
    }

    // all assets
    let results = {}
    for (let a in all) {
      let akey = all[a]
      files = instance[form][akey]
      paths = []
      for (let fi in files) {
        let file = files[fi]
        if (file.hasOwnProperty('raw')) {
          let data = await ApiFile.upload(file, `${prefix}/${akey}`)
          if (data) {
            paths.push({
              name: data.url,
              url: data.fullUrl
            })
          }
        } else {
          // existing
          paths.push(file)
        }
      }
      results[akey] = _.map(paths, (item) => item.name)
    }
    return results
  }

  // new aims

  static camelize (obj) { // method (1)
    return _.transform(obj, (acc, value, key, target) => {
      const camelKey = _.isArray(target) ? key : _.camelCase(key)
      acc[camelKey] = _.isObject(value) ? RequestHelper.camelize(value) : value
    })
  }

  static snakeCase (s) {
    // return _
    //   .chain(s)
    //   .split(/(\d+)/)
    //   .map(RequestUtil.snakeCase)
    //   .join('')
    //   .value()
    if (s && s.includes('.')) {
      return s.split('.')
        .map((w) => RequestHelper.snakeCase(w))
        .join('.')
    }
    return s
      .replace(/[0-9][a-z]/, (b) => b.toUpperCase()) // digit with small letter
      .replace(/\W+/g, ' ')
      .split(/ |\B(?=[A-Z])/) // split any with capital letter
      .map((w) => w.toLowerCase())
      .join('_')
      .replace(/_+/g, '_') // clear duplicates
    // result = [
    //   [snakeCase('scoreA')],
    //   [snakeCase('score0B')],
    //   [snakeCase('w9Status')],
    //   [snakeCase('w9status')],
    //   [snakeCase('w9_Status')],
    //   [snakeCase('w9 Status')],
    //   [snakeCase('object.status')],
    // ]
  }

  static snakize (obj) { // method (1)
    return _.transform(obj, (acc, value, key, target) => {
      const camelKey = _.isArray(target) ? key : RequestHelper.snakeCase(key)
      acc[camelKey] = _.isObject(value) ? RequestHelper.snakize(value) : value
    })
  }
}

export default RequestHelper
